import { applyMiddleware, createStore } from "redux";
import { createRootReducer } from "./reducers";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import { complaintsSaga } from "./sagas";
export const MODULE_NAME = "complaints";
const moduleRootReducer = createRootReducer();
export const moduleReducerDefinition = {
    name: MODULE_NAME,
    reducer: moduleRootReducer,
    saga: complaintsSaga,
};
// Because the Complaints module could be navigated to several times from the parent portal,
//  we only want to create a redux store once and store its reference.  Otherwise we get N stores
//  where N = the number of times the module is visited from the main portal navigation, and hence
//  we get N repeated api calls per action.
let _configureStoreSingleton;
const _configureStore = (history) => {
    const sagaMiddleware = createSagaMiddleware();
    const store = createStore(moduleRootReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));
    sagaMiddleware.run(complaintsSaga);
    return store;
};
export const configureStore = (history) => {
    _configureStoreSingleton = _configureStoreSingleton || _configureStore(history);
    return _configureStoreSingleton;
};
